"use client";

import { c as _c } from "react/compiler-runtime";
import { useMemo } from "react";
import { SIDEBAR_WIDTHS } from "../../constants/sidebar";
import { useSidebarController } from "../../hooks/useSidebarController";
import { SidebarProvider, useSidebarState } from "../../hooks/useSidebarState";
import WebSidebar from "./sidebar/WebSidebar";
import type { CSSProperties, ReactNode } from "react";
const DESKTOP_MAX_WIDTH = 1324;
interface WebLayoutProps {
  readonly children: ReactNode;
  readonly isSmall?: boolean | undefined;
}
const WebLayoutContent = t0 => {
  const $ = _c(25);
  const {
    children,
    isSmall: t1
  } = t0;
  const isSmall = t1 === undefined ? false : t1;
  const {
    isMobile,
    isNarrow,
    isCollapsed,
    isOffcanvasOpen,
    toggleCollapsed,
    closeOffcanvas,
    sidebarWidth
  } = useSidebarController();
  const {
    isRightSidebarOpen
  } = useSidebarState();
  let t2;
  if ($[0] !== sidebarWidth) {
    t2 = {
      "--sidebar-width": sidebarWidth,
      "--collapsed-width": SIDEBAR_WIDTHS.COLLAPSED,
      "--expanded-width": SIDEBAR_WIDTHS.EXPANDED,
      "--layout-max": `${DESKTOP_MAX_WIDTH}px`
    };
    $[0] = sidebarWidth;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const cssVars = t2 as CSSProperties;
  const t3 = isSmall ? "true" : "false";
  let t4;
  if ($[2] !== closeOffcanvas || $[3] !== isCollapsed || $[4] !== isMobile || $[5] !== isNarrow || $[6] !== isOffcanvasOpen || $[7] !== sidebarWidth || $[8] !== toggleCollapsed) {
    t4 = <div className="tailwind-scope"><WebSidebar isCollapsed={isCollapsed} onToggle={toggleCollapsed} isMobile={isMobile} isNarrow={isNarrow} isOffcanvasOpen={isOffcanvasOpen} onCloseOffcanvas={closeOffcanvas} sidebarWidth={sidebarWidth} /></div>;
    $[2] = closeOffcanvas;
    $[3] = isCollapsed;
    $[4] = isMobile;
    $[5] = isNarrow;
    $[6] = isOffcanvasOpen;
    $[7] = sidebarWidth;
    $[8] = toggleCollapsed;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== children || $[11] !== isMobile || $[12] !== isNarrow || $[13] !== isOffcanvasOpen || $[14] !== isRightSidebarOpen) {
    t5 = <main className="layout-main tw-min-w-0 tw-flex-1" data-mobile={isMobile} data-narrow={isNarrow} data-offcanvas={isOffcanvasOpen} data-right-open={isRightSidebarOpen}>{children}</main>;
    $[10] = children;
    $[11] = isMobile;
    $[12] = isNarrow;
    $[13] = isOffcanvasOpen;
    $[14] = isRightSidebarOpen;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== cssVars || $[17] !== isMobile || $[18] !== isNarrow || $[19] !== isOffcanvasOpen || $[20] !== isRightSidebarOpen || $[21] !== t3 || $[22] !== t4 || $[23] !== t5) {
    t6 = <div className="layout-root tw-relative tw-flex tw-w-full tw-justify-between" style={cssVars} data-mobile={isMobile} data-narrow={isNarrow} data-offcanvas={isOffcanvasOpen} data-right-open={isRightSidebarOpen} data-small={t3}>{t4}{t5}</div>;
    $[16] = cssVars;
    $[17] = isMobile;
    $[18] = isNarrow;
    $[19] = isOffcanvasOpen;
    $[20] = isRightSidebarOpen;
    $[21] = t3;
    $[22] = t4;
    $[23] = t5;
    $[24] = t6;
  } else {
    t6 = $[24];
  }
  return t6;
};
const WebLayout = t0 => {
  const $ = _c(3);
  const {
    children,
    isSmall: t1
  } = t0;
  const isSmall = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== children || $[1] !== isSmall) {
    t2 = <SidebarProvider><WebLayoutContent isSmall={isSmall}>{children}</WebLayoutContent></SidebarProvider>;
    $[0] = children;
    $[1] = isSmall;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
export default WebLayout;